import axios from 'axios';
import apiUrl from '../../api.config';

const CLASS_YEAR_API_URL = `${apiUrl}classYear`;

class ClassYearService {
   add(classYearData) {
    return axios.post(CLASS_YEAR_API_URL+"/add", classYearData, {
      headers: {
        'x-access-token': `${localStorage.getItem('accessToken')}`
      }
    });
  }

   findAll() {
    return axios.get(CLASS_YEAR_API_URL+"/get", {
      headers: {
        'x-access-token': `${localStorage.getItem('accessToken')}`
      }
    });
  }

   findBySchool() {
    return axios.get(`${CLASS_YEAR_API_URL}/bySchool/`, {
      headers: {
        'x-access-token': `${localStorage.getItem('accessToken')}`
      }
    });
  }

   update(id, updateData) {
    return axios.put(`${CLASS_YEAR_API_URL}/update/${id}`, updateData, {
      headers: {
        'x-access-token': `${localStorage.getItem('accessToken')}`
      }
    });
  }

   delete(id) {
    return axios.delete(`${CLASS_YEAR_API_URL}/delete/${id}`, {
      headers: {
        'x-access-token': `${localStorage.getItem('accessToken')}`
      }
    });
  }
}

export default new ClassYearService();